import { render, staticRenderFns } from "./GoodsListView.vue?vue&type=template&id=9a692014&lang=true"
import script from "./GoodsListView.vue?vue&type=script&lang=js"
export * from "./GoodsListView.vue?vue&type=script&lang=js"
import style0 from "./GoodsListView.vue?vue&type=style&index=0&id=9a692014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports